import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { InboxPage } from './pages/InboxPage';
import { TasksPage } from './pages/TasksPage';
import { TaskDetailPage } from './pages/TaskDetailPage';
import { NewTaskPage } from './pages/NewTaskPage';
import { AuditPage } from './pages/AuditPage';
import { DomainsPage } from './pages/DomainsPage';

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { index: true, element: <InboxPage /> },
      { path: 'tasks', element: <TasksPage /> },
      { path: 'tasks/new', element: <NewTaskPage /> },
      { path: 'tasks/:id', element: <TaskDetailPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'domains', element: <DomainsPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
